"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const keautils_1 = require("keautils");
const fielderror_1 = require("./fields/fielderror");
const index_1 = require("./botones/index");
const rx_1 = require("./rx");
/**Vista para un titulo */
class TitleNoRx extends React.PureComponent {
    render() {
        const children = this.props.children;
        const childArr = children == null ? [] : keautils_1.isArray(children) ? children : [children];
        const childArrEx = [
            React.createElement(fielderror_1.FieldErrorView, { error: this.props.error }),
            ...childArr,
            this.props.onRefrescar && React.createElement(index_1.RefrescarButton, { onClick: this.props.onRefrescar }),
            this.props.onLimpiar && React.createElement(index_1.LimpiarButton, { onClick: this.props.onLimpiar }),
            this.props.onAgregar && React.createElement(index_1.AgregarButton, { onClick: this.props.onAgregar }),
            this.props.onRegresar && React.createElement(index_1.RegresarButton, { onClick: this.props.onRegresar }),
        ];
        const tituloLabel = (this.props.size == "span" && typeof (this.props.titulo) == "string") ? React.createElement("b", null, this.props.titulo) : this.props.titulo;
        const childElements = childArrEx.map(child => React.createElement("div", { style: { flex: "0 1 auto" } }, child));
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexWrap: "wrap", alignItems: "center" } }, ...[
                React.createElement("div", { style: { flex: "0 1 auto" } }, React.createElement(this.props.size || "h3", {}, ...[
                    this.props.iconClass && React.createElement("i", { className: this.props.iconClass }),
                    tituloLabel
                ])),
                React.createElement("div", { style: { flex: "1 1 auto" } }),
                ...childElements,
            ]),
            (this.props.line === undefined || this.props.line) && React.createElement("hr", null)));
    }
}
exports.Title = rx_1.componentToRxSpinner(TitleNoRx);



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/title.js
// module id = 301
// module chunks = 0